import { JSX, useEffect, useRef, useState } from "react"
import { X } from "react-feather"
import dayjs from 'dayjs';
import { Input, Button, ButtonGroup, Box, Stack, TextareaAutosize } from "@mui/material"
import { TimePicker } from "@mui/x-date-pickers";
import { ColorChangeSource, ColorPicker, ColorSwatchButton, LinkBubbleMenu, LinkBubbleMenuHandler, MenuButtonBold, MenuButtonBulletedList, MenuButtonColorPicker, MenuButtonHighlightColor, MenuButtonItalic, MenuButtonTextColor, MenuControlsContainer, MenuDivider, MenuSelectHeading, RichTextEditor, RichTextEditorRef } from "mui-tiptap";
import StarterKit from "@tiptap/starter-kit";
import { TableKit } from "@tiptap/extension-table";
import { BackgroundColor, Color, TextStyle } from "@tiptap/extension-text-style";
import { decodeHTMLEntities } from "../../services/TextConverter";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';
import { deDE } from '@mui/x-date-pickers/locales';
import mainservice from "../../services/MainService";

export default function InputB (props: {
  returnVal: (value: string) => void,
  value?: string,
  delay?: number,
  className?: string,
  placeholder?: string,
  clearButton?: boolean,
  autofocus?: boolean,
  type?: 'singleline' | 'textarea' | 'date' | 'time' | 'number' | 'wysiwyg',
  rows?: number,
  sendButton?: string,
  disabled?: boolean,
  multiline?: boolean,
  contentSuffix?: JSX.Element,
  noGrouping?: boolean,
  sx?: object,
  sxButton?: object,
}) {
  const [timeoutHolder, setTimeoutHolder] = useState(setTimeout(() => {}, 500))
  const [currentValue, setCurrentValue] = useState(props.value || '')
  const [lastSendValue, setLastSendValue] = useState(props.value || '')
  const rteRef = useRef<RichTextEditorRef>(null);
  useEffect(() => {
    if (props.value !== undefined) {
      setCurrentValue(props.value)
      setLastSendValue(props.value)
    }
    // console.log('a', props.value)
  }, [props.value])
  let inputBox = null
  switch(props.type) {
    case 'time':
      inputBox = <TimePicker
          slotProps={{
            textField: {
              error: false,
              sx: {
                height: 40, // Passt die äußere Komponentenhöhe an (z.B. gleiche Hoehe wie Buttons)
                '& .MuiInputBase-root': {
                  height: 40,
                },
                '& .MuiInputBase-input': {
                  height: 40,
                  boxSizing: 'border-box',
                  padding: '0 14px',
                },
                '& .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
                  padding: '9px 0',
                }
              }
            }
          }}
          defaultValue={dayjs(currentValue)}
          onChange={(raw) => {
            if (!raw) { return }
            const value = raw.format('HH:mm')
            setCurrentValue(value)
            if (value !== lastSendValue) {
              props.returnVal(value)
              setLastSendValue(value)
            }
          }}
          ampm={false}
        />
      break
    case 'date':
      inputBox = <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale="de"
        localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <DatePicker
          slotProps={{
            textField: {
              error: false,
              sx: {
                height: 40, // Passt die äußere Komponentenhöhe an (z.B. gleiche Höhe wie Buttons)
                '& .MuiInputBase-root': {
                  height: 40,
                },
                '& .MuiInputBase-input': {
                  height: 40,
                  boxSizing: 'border-box',
                  padding: '0 14px',
                },
                '& .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
                  padding: '9px 0',
                }
              }
            }
          }}
          value={dayjs(currentValue)}
          onChange={(raw) => {
            if (!raw) { return }
            const value = raw.format('YYYY-MM-DD')
            setCurrentValue(value)
            clearTimeout(timeoutHolder)
            if (props.delay === -1) { return }
            setTimeoutHolder(setTimeout(() => {
              if (value !== lastSendValue) {
                props.returnVal(value)
                setLastSendValue(value)
              }
            }, (props.delay === undefined) ? 1000 : props.delay))
          }}
          disabled={!!props.disabled}
        />
      </LocalizationProvider>
      break
    case 'textarea':
      inputBox = <Stack direction='column' spacing={2} sx={{width: '100%', maxWidth: '100%'}}>
        {props.rows && props.rows === 1 ?
          <textarea
            title="rowrow"
            
            rows={props.rows}
          
            // disableUnderline
            className='w100'
            style={{
              height: "1em !important",
              minHeight: 0,
              maxHeight: '24px',
              width: '100% !important',
            }}
            /*
            sx={{
              border: '1px solid grey',
              borderRadius: (props.sendButton || props.clearButton) ? '0 10px 10px 0' : '10px',
              ...(props.sx || {})
            }}
              */
            value={props.multiline ? currentValue.replace(/<br\s*\/?>/g, '\n') : currentValue}
            placeholder={props.placeholder}
            autoFocus={true}
            // rows={props.rows || undefined}
            onChange={(event) => {
              const value = props.multiline ? event.target.value.replace(/\r?\n/g, '<br />') : event.target.value
              setCurrentValue(value)
              if (props.delay === -1) { return }
              console.log('onchange', value)
              clearTimeout(timeoutHolder)
              setTimeoutHolder(setTimeout(() => {
                if (value !== lastSendValue) {
                  props.returnVal(value)
                  setLastSendValue(value)
                }
              }, (props.delay === undefined) ? 1000 : props.delay))
            }}
            onKeyDown={(event) => {
              console.log('keydown', event.key)
              if (props.delay !== -1) { return }
              if (event.key === 'Enter' || event.key === 'Return') {
                event.preventDefault()
                props.returnVal(currentValue)
                setLastSendValue(currentValue)
              }
            }}
            onFocus={() => {
              mainservice.broadcast('textEditFocus', true)
            }}
            onBlur={() => {
              mainservice.broadcast('textEditBlur', true)
            }}
          />
        :
          <TextareaAutosize
            // disableUnderline
            className='flex-grow'
            /*
            sx={{
              border: '1px solid grey',
              borderRadius: (props.sendButton || props.clearButton) ? '0 10px 10px 0' : '10px',
              ...(props.sx || {})
            }}
              */
            value={props.multiline ? currentValue.replace(/<br\s*\/?>/g, '\n') : currentValue}
            placeholder={props.placeholder}
            autoFocus={true}
            // rows={props.rows || undefined}
            onChange={(event) => {
              const value = props.multiline ? event.target.value.replace(/\r?\n/g, '<br />') : event.target.value
              setCurrentValue(value)
              if (props.delay === -1) { return }
              console.log('onchange', value)
              clearTimeout(timeoutHolder)
              setTimeoutHolder(setTimeout(() => {
                if (value !== lastSendValue) {
                  props.returnVal(value)
                  setLastSendValue(value)
                }
              }, (props.delay === undefined) ? 1000 : props.delay))
            }}
            onKeyDown={(event) => {
              console.log('keydown', event.key)
              if (props.delay !== -1) { return }
              if (event.key === 'Enter' || event.key === 'Return') {
                event.preventDefault()
                props.returnVal(currentValue)
                setLastSendValue(currentValue)
              }
            }}
            onFocus={() => {
              mainservice.broadcast('textEditFocus', true)
            }}
            onBlur={() => {
              mainservice.broadcast('textEditBlur', true)
            }}
          />
        }
        
        {
          !props.noGrouping &&
          <Button
            variant="contained"
            onClick={() => {
              props.returnVal(currentValue)
            }}
            sx={props.sxButton || {}}
          >{props.sendButton || 'Senden'}</Button>
        }
        </Stack>
      break
    case 'wysiwyg':
      inputBox = <Stack
        spacing={2}
        sx={{width: '100%'}}
      >
        <RichTextEditor
          sx={{ width: '100%' }}
          ref={rteRef}
          extensions={[
            StarterKit,
            TableKit.configure({
              table: { resizable: true },
            }),
            TextStyle,
            Color,
            BackgroundColor, // Hintergrundfarbe
            LinkBubbleMenuHandler
          ]}
          content={currentValue}
          renderControls={() => (
            <MenuControlsContainer>
              <MenuSelectHeading />
              <MenuDivider />
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuButtonBulletedList />
              <MenuButtonTextColor
                swatchColors={[
                  '#424242',
                  '#fcea17',
                  '#77e324',
                  '#f00',
                  '#9090ff'
                ]}
              />
              <LinkBubbleMenu />
            </MenuControlsContainer>
          )}
        />
        <Box>
          <Button
            onClick={async () => {
              let value = rteRef.current?.editor?.getHTML()
              if (value === undefined) { return }
              console.log('value', value)
              value = decodeHTMLEntities(value)
              props.returnVal(value || '')
              setLastSendValue(value || '')
            }}
          >
            {props.sendButton || 'Speichern'}
          </Button>
        </Box>
      </Stack>
      break
    default:
      inputBox = <Input
        sx={{
          border: '1px solid grey',
          borderRadius: (props.sendButton || props.clearButton) ? '0 10px 10px 0' : '10px',
        }}
        disableUnderline
        className='flex-grow'
        value={currentValue}
        placeholder={props.placeholder}
        autoFocus={!!props.autofocus}
        onPaste={(event) => {
          event.preventDefault()
          const value = event.clipboardData.getData("Text")
          setCurrentValue(value)
          clearTimeout(timeoutHolder)
          if (props.delay === -1) { return }
          setTimeoutHolder(setTimeout(() => {
            if (value !== lastSendValue) {
              props.returnVal(value)
              setLastSendValue(value)
            }
          }, (props.delay === undefined) ? 1000 : props.delay))
        }}
        onChange={(event) => {
          const value = event.target.value
          setCurrentValue(value)
          clearTimeout(timeoutHolder)
          if (props.delay === -1) { return }
          setTimeoutHolder(setTimeout(() => {
            if (value !== lastSendValue) {
              props.returnVal(value)
              setLastSendValue(value)
            }
          }, (props.delay === undefined) ? 1000 : props.delay))
        }}
        onKeyDown={(event) => {
          console.log('keydown', event.key)
          if (props.delay !== -1) { return }
          if (event.key === 'Enter' || event.key === 'Return') {
            event.preventDefault()
            props.returnVal(currentValue)
            setLastSendValue(currentValue)
          }
        }}
        onFocus={() => {
          mainservice.broadcast('textEditFocus', true)
        }}
        onBlur={() => {
          mainservice.broadcast('textEditBlur', true)
        }}
        disabled={!!props.disabled}
      />
  }
  if (props.noGrouping || props.type === 'textarea') {
    return inputBox
  }
  return <ButtonGroup
    className={props.className || ''}
  >
    {
      props.sendButton &&
      <Button
        variant="contained"
        onClick={() => {
          props.returnVal(currentValue)
        }}
      >{props.sendButton}</Button>
    }
    {
      props.clearButton &&
      <Button
        variant="outlined"
        onClick={() => {
          setCurrentValue('')
          setLastSendValue('')
          props.returnVal('')
        }}
      ><X /></Button>
    }
    {
      inputBox
    }
    
      {props.contentSuffix || null}

  </ButtonGroup>
}
